// Articles
export const authorStructuredData = (authorByline) => {
  return authorByline.map((author) => {
    return {
      '@type': 'Person',
      name: author.authorName.trim(),
      url: `/studio/${author.slug}`,
    };
  });
};

export const articleStructuredData = (
  { headline, copyBrief, pubDate, authorByline },
  imageUrl
) => {
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: headline,
    description: copyBrief ? copyBrief : headline,
    datePublished: new Date(pubDate).toISOString(),
    author: authorStructuredData(authorByline),
  };

  if (imageUrl) {
    articleSchema.image = imageUrl;
  }

  return articleSchema;
};

// FAQs
export const faqStructuredData = (faqData) => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: qaStructuredData(faqData),
  };

  return faqSchema;
};

export function qaStructuredData(faqData) {
  let data = [];
  faqData?.forEach((entry) => {
    data.push({
      '@type': 'Question',
      name: entry.faqQuestion,
      acceptedAnswer: {
        '@type': 'Answer',
        text: entry.faqAnswer,
      },
    });
  });

  return data;
}

// Products
export const productStructuredData = (
  name,
  imageUrl,
  url,
  price,
  availability
) => {
  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    image: imageUrl,
    brand: {
      '@type': 'Brand',
      name: 'Clayton Homes',
    },
    offers: {
      '@type': 'Offer',
      url,
      priceCurrency: 'USD',
      price: String(price),
      availability,
    },
  };

  return productSchema;
};
